import { styled } from '@mui/material/styles';
import { Box, Tab, Tabs } from '@mui/material';

export const TabsPositionWrapper = styled(Box)(({ theme }) => ({
    margin: '0 -16px 30px',
    display: 'flex',
    flexShrink: 0,
    justifyContent: 'center',
    borderBottom: `1px solid ${theme.palette.divider}`,

    [theme.breakpoints.up('sm')]: {
        marginLeft: '-24px',
        marginRight: '-24px',
    },

    [theme.breakpoints.up('md')]: {
        display: 'block',
        width: '300px',
        margin: '70px 0 0',
        padding: '0 20px 0 0',
        border: '0',
    },

    [theme.breakpoints.up('lg')]: {
        width: '370px',
    },
}));

export const TabsBox = styled(Tabs)({
    maxHeight: '600px',
});

export const TabButton = styled(Tab)(({ theme }) => ({
    maxWidth: 'inherit',
    minHeight: '38px',
    padding: '6px 15px',
    fontSize: theme.typography.pxToRem(14),
    fontWeight: 700,
    letterSpacing: '0.3px',
    opacity: '0.4',
    alignItems: "center",           // Vertical center always
    justifyContent: "center",       // NEW: Mobile centered (override to flex-start on md+)
    color: "inherit",

    '&.Mui-selected': {
        opacity: '1',
        color: "inherit",
    },

    [theme.breakpoints.up('md')]: {
        fontSize: theme.typography.pxToRem(15),
        justifyContent: "flex-start",  // FIXED: Left-align on md+
    },

    [theme.breakpoints.up('lg')]: {
        marginBottom: '5px',
    },

    '& .MuiTab-wrapper': {
        lineHeight: '1.5',
        flexDirection: 'row',
        letterSpacing: '0.3px',
        display: 'flex',
        alignItems: 'center',           // Vertical center icon + text always
        justifyContent: 'center',       // Mobile: center entire content
        textAlign: 'center',            // Mobile: center text

        '& .tab-error-icon': {
            display: 'flex',
            flexShrink: 0,
            color: theme.palette.error.light,
            margin: '0 5px 0 0',        // Horizontal spacing (icon left of text)

            '&:first-of-type': {
                margin: '0 5px 0 0',    // Consistent, no bottom
            },
        },

        '& .tab-label': {
            flex: 1,
        },

        [theme.breakpoints.up('md')]: {
            justifyContent: 'flex-start',   // Desktop: left-align content
            textAlign: 'left',              // Desktop: left-align text
        },
    }
}));


